import { register } from "@shopify/theme-sections";

register("contact-form", {

  formHandle() {
    const form = document.querySelector('[data-zendesk-form]');

    form.addEventListener('submit', (e) => {

      let formData = new FormData(form);
      let filesCollected = false;
      let groupsIDs = {
        "Cancel": 360006321954,
        "Defective": 360005342154,
        "Exchanges": 360006198094,
        "Order Status": 360005432854,
        "Place Order": 360005468273,
        "Quality": 4932385164186,
        "Returns": 360005320754,
        "Support": 360004822553
      };
    
      for (let [key, value] of formData) {
        if (key == 'first-name'){
          key = 'name';
          value = `${formData.get('first-name')} ${formData.get('last-name')}`;
          formData.delete('first-name');
          formData.delete('last-name');
          formData.append("name", value);
        }
        if (key == 'subject') formData.append('group_id',groupsIDs[value])
        if (key == 'attachments[]' && formData.get('attachments[]').size){
          if (!filesCollected){
            formData.delete('attachments[]');
            let fileInput = document.getElementById('ContactFormAttachment');
            let ins = fileInput.files.length;
            for (let x = 0; x < ins; x++) {
              const fileSize = fileInput.files[x].size / 1024 / 1024; // in MiB
              if (fileSize > 1) {
                document.querySelector('.contact-us__errors').style.display = "block";
                document.querySelector('.contact-us__errors').textContent = 'File size should be less 1MB';
                window.scroll({
                  top: 0,
                  behavior: "smooth",
                });
                fileInput.addEventListener('change', () => {
                  document.querySelector('.contact-us__errors').style.display = "none";
                });
                e.preventDefault();
                return false;
              } else {
                formData.append("attachments[]", fileInput.files[x], fileInput.files[x].name);
              }
            }
            filesCollected = true;
          }
        }
      }

      form.querySelector('input[type="submit"]').value = "Sending...";
      form.querySelector('input[type="submit"]').setAttribute('disabled', 'disabled');

      let myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formData,
        redirect: 'follow'
      };

      fetch("https://www.reef.com/a/api/zendesk/request/create", requestOptions)
        .then(response => response.text())
        .then(result => {
          let resultJson = JSON.parse(result);
          if (resultJson.status == 201){
            document.querySelector('.contact-us__success').style.display = "block";
            form.querySelector('input[type="submit"]').value = "Request Sent";
            form.querySelector('input[type="submit"]').removeAttribute('disabled');
            window.scroll({
              top: 0,
              behavior: "smooth",
            });
            form.reset();
          }
        })
        .catch(error => console.log('error', error));

      e.preventDefault();
      return false;
    })
    

  },

  scrollToStart() {
    setTimeout(() => {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    }, 500);
  },
  onLoad: function () {
    this.scrollToStart();
    this.formHandle();
  },
});
